<h1 mat-dialog-title class="folder-selection-dialog__title high-contrast-text">
  <span class="folder-selection-dialog__title-text">
    {{ data.titleKey ? (data.titleKey | translate) : data.title }}
  </span>
</h1>

<div mat-dialog-content class="folder-selection-dialog__content">
  <tiwp-tab-bar
    *ngIf="tabs.length"
    class="folder-selection-dialog__tabs"
    [tabs]="tabs"
    [currentTabIndex]="currentTabIndex"
    (change)="onWorkspaceChange($event)"
  >
  </tiwp-tab-bar>
  <div class="folder-selection-dialog__tree-shell">
    <!-- Recreate the tree when the workspace changes: MatNestedTree keeps a stale view if only itemsTree is swapped. -->
    <tiwp-item-tree
      *ngFor="let workspace of [activeWorkspace]"
      [selectedNode]="selectedFolder || displayedFolders"
      [editable]="false"
      [startExpanded]="true"
      [itemsTree]="displayedFolders"
      (click)="stopPropagation($event)"
      (itemClick)="selectFolder($event)"
      (provideExpandBreadcrumb)="getExpandBreadcrumb($event)"
    >
    </tiwp-item-tree>
  </div>
</div>
